<template>
  <div class="content">
    <v-row class="search_box">
      <v-col>
        <topNav></topNav>
      </v-col>
    </v-row>
    <div class="main_container">
      <div class="md_title mart24 marb12">企业管理</div>
      <div style="margin-left:-25px; margin-top:-14px;">
        <v-breadcrumbs :items="items">
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>
      </div>
      <v-row>
        <v-col>
          <div class="firm_list_wrapper martop14">
            <span class="mart20">排序方式：</span>
            <div class="firm_list_top marb12 mart8">
              <v-tabs mart24
                      padTop
                      :class="{'tab_detail1':true,'custom_style1': !isPhone}"
                      @change="handleChange"
                      v-model="activeKey">
                <v-tab key="1">
                  专利总量
                </v-tab>
                <v-tab key="2">
                  发明授权
                </v-tab>
                <v-tab key="3">
                  发明公开</v-tab>
                <v-tab key="4">
                  发明总量</v-tab>
                <v-tab key="5">
                  实用新型</v-tab>
                <v-tab key="6">
                  外观设计</v-tab>
                <v-tab key="7">
                  商标总量</v-tab>
                <v-tab key="8">
                  软著总量</v-tab>
                <v-tab-item key="1">
                  <div class="firm_list_center"   v-if="activeKey == 0" >
                    <v-data-table v-model="selectKeys"
                                  item-key="name"
                                  :headers="headers"
                                  :items="list"
                                  class="common_table"
                                  @click:row="rowClicktable"
                                  :items-per-page="itemsPerPage"
                                  hide-default-footer>
                       <template v-slot:[`item.numPa`]="{ item }">
                             <div class="tips_box"
                                    style="color:#F0446C;"
                                             >
                                             {{item.numPa}}
                                            </div>
                      </template>
                    </v-data-table>
                    <!---第一个分页-->
                    <div class="hist_pagination">
                      <v-row>
                        <v-col class="common_pagePase  left">
                          <v-pagination v-model="currentPage"
                                        :length="pageLength"
                                        :total-visible="pageVisible">
                          </v-pagination>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item key="2">
                  <div class="firm_list_center"   v-if="activeKey == 1" >
                    <v-data-table v-model="selectKeys"
                                  item-key="id"
                                  :headers="headers"
                                  :items="list"
                                  class="common_table"
                                  :items-per-page="itemsPerPage"
                                  hide-default-footer>   
                 <template v-slot:[`item.numPaInventGrant`]="{ item }">
                             <div class="tips_box"
                                    style="color:#F0446C;"
                                             >
                                             {{item.numPaInventGrant}}
                                            </div>
                      </template>

                    </v-data-table>
                    <!---2-->
                    <div class="hist_pagination">
                      <v-row>
                        <v-col class="common_pagePase  left">
                            <v-pagination v-model="currentPageOne"
                                        :length="pageLength"
                                        :total-visible="pageVisible">
                          </v-pagination>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item key="3">
                  <div class="firm_list_center"  v-if="activeKey == 2" >
                    <v-data-table v-model="selectKeys"
                                  item-key="id"
                                  :headers="headers"
                                  :items="list"
                                  class="common_table"
                                  :items-per-page="itemsPerPage"
                                  hide-default-footer>
                                     <template v-slot:[`item.numPaInventPublication`]="{ item }">
                             <div class="tips_box"
                                    style="color:#F0446C;"
                                             >
                                             {{item.numPaInventPublication}}
                                            </div>
                      </template>
                    </v-data-table>
                    <!---3-->
                    <div class="hist_pagination">
                      <v-row>
                        <v-col class="common_pagePase  left">
                           <v-pagination v-model="currentPageTwo"
                                        :length="pageLength"
                                        :total-visible="pageVisible">
                          </v-pagination>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item key="4">
                  <div class="firm_list_center"  v-if="activeKey == 3">
                    <v-data-table v-model="selectKeys"
                                  item-key="id"
                                  :headers="headers"
                                  :items="list"
                                  class="common_table"
                                  :items-per-page="itemsPerPage"
                                  hide-default-footer>
                                   <template v-slot:[`item.numPaInvent`]="{ item }">
                             <div class="tips_box"
                                    style="color:#F0446C;"
                                             >
                                             {{item.numPaInvent}}
                                            </div>
                      </template>
                    </v-data-table>
                    <!---4-->
                    <div class="hist_pagination">
                      <v-row>
                        <v-col class="common_pagePase  left">
                           <v-pagination v-model="currentPageThree"
                                        :length="pageLength"
                                        :total-visible="pageVisible">
                          </v-pagination>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item key="5">
                  <div class="firm_list_center"  v-if="activeKey == 4">
                    <v-data-table v-model="selectKeys"
                                  item-key="id"
                                  :headers="headers"
                                  :items="list"
                                  class="common_table"
                                  :items-per-page="itemsPerPage"
                                  hide-default-footer>
                                   <template v-slot:[`item.numPaUtility`]="{ item }">
                             <div class="tips_box"
                                    style="color:#F0446C;"
                                             >
                                             {{item.numPaUtility}}
                                            </div>
                      </template>

                    </v-data-table>
                    <!---5-->
                    <div class="hist_pagination">
                      <v-row>
                        <v-col class="common_pagePase  left">
                           <v-pagination v-model="currentPageFour"
                                        :length="pageLength"
                                        :total-visible="pageVisible">
                          </v-pagination>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item key="6">
                  <div class="firm_list_center"  v-if="activeKey ==5">
                    <v-data-table v-model="selectKeys"
                                  item-key="id"
                                  :headers="headers"
                                  :items="list"
                                  class="common_table"
                                  :items-per-page="itemsPerPage"
                                  hide-default-footer>
                                     <template v-slot:[`item.numPaDesign`]="{ item }">
                             <div class="tips_box"
                                    style="color:#F0446C;"
                                             >
                                             {{item.numPaDesign}}
                                            </div>
                      </template>

                    </v-data-table>
                    <!---6-->
                    <div class="hist_pagination">
                      <v-row>
                        <v-col class="common_pagePase  left">
                           <v-pagination v-model="currentPageFive"
                                        :length="pageLength"
                                        :total-visible="pageVisible">
                          </v-pagination>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item key="7">
                  <div class="firm_list_center"  v-if="activeKey == 6">
                    <v-data-table v-model="selectKeys"
                                  item-key="id"
                                  :headers="headers"
                                  :items="list"
                                  class="common_table"
                                  :items-per-page="itemsPerPage"
                                  hide-default-footer>
                                     <template v-slot:[`item.numTm`]="{ item }">
                             <div class="tips_box"
                                    style="color:#F0446C;"
                                             >
                                             {{item.numTm}}
                                            </div>
                      </template>

                    </v-data-table>
                    <!---7-->
                    <div class="hist_pagination">
                      <v-row>
                        <v-col class="common_pagePase  left">
                           <v-pagination v-model="currentPageSix"
                                        :length="pageLength"
                                        :total-visible="pageVisible">
                          </v-pagination>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item key="8">
                  <div class="firm_list_center"  v-if="activeKey == 7">
                    <v-data-table v-model="selectKeys"
                                  item-key="id"
                                  :headers="headers"
                                  :items="list"
                                  class="common_table"
                                  :items-per-page="itemsPerPage"
                                  hide-default-footer>
                                    <template v-slot:[`item.numRz`]="{ item }">
                             <div class="tips_box"
                                    style="color:#F0446C;"
                                             >
                                             {{item.numRz}}
                                            </div>
                      </template>
                    </v-data-table>
                    <!--8-->
                    <div class="hist_pagination">
                      <v-row>
                        <v-col class="common_pagePase  left">
                           <v-pagination v-model="currentPageSeven"
                                        :length="pageLength"
                                        :total-visible="pageVisible">
                          </v-pagination>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs>
            </div>

          </div>
        </v-col>
      </v-row>
    </div>
    <!---pdf的弹窗-->
    <v-dialog v-model="visible"
              width="80%">
      <div class="pdf_wrapper">
        <v-card>
          <v-card-title>PDF全文
            <v-icon @click="visible=false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <div style="height: 100%;">
              <embed :src="src"
                     type="application/pdf"
                     width="100%"
                     height="100%" />
            </div>
          </v-card-text>
          <v-divider></v-divider>
        </v-card>
      </div>
    </v-dialog>
    <!---->
  </div>
</template>
<script>
import topNav from '@/components/widgets/topNav.vue'
import companyList from '../../assets/company.json'
import { mapActions } from 'vuex'
import Qs from 'qs'
import Template from '../../components/widgets/template.vue'
export default {
  data() {
    return {
      items: [
        {
          text: '企业管理',
          disabled: false,
          href: '/#/manage',
        },
        {
          text: '企业排行榜',
          disabled: false,
          // href: '/manager#/knowledge'
        },
      ],
      visible: '',
      src: '',
      page: 1, //当前页面号
      itemsPerPage: 20, //每页条目数
      pageLength: 0, //总页面数
      pageLengthTwo: 0,
      currentPageOne:1,
      currentPageTwo:1,
      currentPageThree:1,
      currentPageFour:1,
      currentPageFive:1,
      currentPageSix:1,
      currentPageSeven:1,
      pageVisible: 7, //分页条中可见页面号数
      detailVisible: false,
      isPhone: false,
      // activeKey: '1',
      activeKey: '0',
      sort: 'desc',
      sort1: 'desc',
      sort2: 'desc',
      sort3: 'desc',
      sort4: 'desc',
      sort5: 'desc',
      list: [],
      selectKeys: [],
        currentParams: {
            params: {
              gid: 1,
              page: this.currentPage,
              pageSize: this.pageSize,
              sortField: 'total',
              length:null,
              sortDirection: 'desc',
            }
          },
      addVisible: false,
      visibleTit: '添加企业',
      informationVisible: false, //工商信息
      itemsPerPageAllText: '',
      currentPage: 1,
      pageSize: 20,
      form: {},
      companyName: '',
      detailInfo2: '',
      name: '',
      headers: [
        { text: '排名', value: 'index', sortable: false },
        { text: '企业名称', value: 'companyName', sortable: false },
        { text: '发明授权', value: 'numPaInventGrant', sortable: false },
        {
          text: '发明公开',
          value: 'numPaInventPublication',
          sortable: false,
        },
        { text: '发明总量', value: 'numPaInvent', sortable: false },
        { text: '实用新型', value: 'numPaUtility', sortable: false },
        { text: '外观设计', value: 'numPaDesign', sortable: false },
        { text: '专利总量', value: 'numPa', sortable: false },
        { text: '商标总量', value: 'numTm', sortable: false },
        { text: '著作权总量', value: 'numRz', sortable: false },
        { text: '知产总量', value: 'numTotal', sortable: false },
      ],
     
    }
  },
  computed: {},
  mounted() {
    this.getList()
  },
  watch: {
    currentPage() {
      this.getList()
    },
    currentPageOne(){
       this.sortList()
    },
    currentPageTwo(){
       this.sortPub()
    },
     currentPageThree(){
       this.sortPainvent()
    },
    //使用新型
     currentPageFour(){
       this.sortPautility()
    },
     currentPageFive(){
       this.sortPadesign()
    },
      currentPageSix(){
       this.sortTm()
    },
    currentPageSeven(){
      this.sortRz()

    }
  },
  components: {
    topNav
  },
  created() {
    this.getList()
    this.name = this.$route.query.name
  },
  methods: {
    //列表的数据
    ...mapActions('manage', [
      'getCompanies',
      'getmanageUpdate',
      'getmanageManageAdd',
      'getmanageManageDelete',
      'getmanageManageSearch',
      'getmanaGemanagePatent',
      'getmanageCompanyindex',
    ]),
    ...mapActions('search', ['querySearch', 'getPatentPdf']),
    zhishiCompany(val) {
      this.viewId = val
      this.visible = true
      this.getPdf()
    },
    getPdf(type) {
      let id = this.viewId
      if (type == '1') {
        id = this.id
      }
      if (type == '2') {
        id = this.id1
      }
      if (type == '3') {
        id = this.doubleId
      }
      let data = {
        params: {
          udn: id,
        },
      }
      let _this = this
      this.getPatentPdf({
        data: data,
        handle(res) {
          _this.src1 = res.pdf.pdfPath
          _this.src = _this.$store.state.baseUrl + res.pdf.pdfPath
          if (type == '1') {
            _this.src2 = _this.$store.state.baseUrl + res.pdf.pdfPath
          }
          if (type == '2') {
            _this.src3 = _this.$store.state.baseUrl + res.pdf.pdfPath
          }
        },
      })
    },
    //table的切换的按钮
    handleChange(val) {
      // console.log(val, '===val===')
      if (val == 0 ) {
        this.getList()
      }
      if (val == 1) {
        this.currentPageOne=1
       this.list= []
        this.sortList()
      }
      if (val == 2) {
         this.currentPageTwo = 1
       this.list= []
        this.sortPub()
      }
      if (val == 3) {
         this.currentPageThree = 1
       this.list= []
      //  this.pageLength = ''
        this.sortPainvent()
      
      }
      if (val == 4) {
         this.currentPageFour = 1
       this.list= []
      //  this.pageLength = ''
        this.sortPautility()
      }
      if (val == 5) {
         this.currentPageFive = 1
       this.list= []
      //  this.pageLength = ''
        this.sortPadesign()
      }
      if (val == 6) {
         this.currentPageSix = 1
       this.list= []
      //  this.pageLength = ''
        this.sortTm()
      }
      if (val == 7) {
         this.currentPageSeven = 1
       this.list= []
      //  this.pageLength = ''
        this.sortRz()
      }
      if (this.$route.query.tab && this.$route.query.tab == 'like') {
        // this.$router.replace('')
      }
    },

    //第一个列表的页面
    rowClicktable: function (item, row) {
      row.select(true)
      let codes = this.list.map((item) => {
        return item.name
      })
      let value = codes.join(' OR ')
      let temp = 'ap:( ' + item.name + ' )'
      this.$router.push({
        // path: "/search/result",
        query: {
          str: temp,
        },
      })
    },

    //列表的数据
    ...mapActions('manage', [
      'getCompanies',
      'getmanageUpdate',
      'getmanageManageAdd',
      'getmanageManageDelete',
      'getmanageManageSearch',
      'getmanageCompanyindex',
    ]),
       //专利总量
    getList() {
      let _this = this
			this.currentParams = data;
       let data = {
        params: {
          gid: 1,
          page: this.currentPage,
          pageSize: this.pageSize,
          // sortField: 'total',
           sortField:'pa',
          sortDirection: 'desc',
        },
      }
      this.currentParams = data
      this.getmanageCompanyindex({
        data: data,
        handle(res) {
          let list = res.message.data
          _this.list = res.message.data
          _this.pageLength= parseInt(res.message.pages)
          //  console.log( _this.list,'=== _this.list===')
        },
      })
     
    },
    
    //发明授权
    sortList() {
       this.list = []
      let _this = this
      let data = {
        params: {
          gid: 1,
           page: this.currentPageOne,
          pageSize: this.pageSize,
          sortField: 'pa_invent_grant',
          sortDirection: 'desc',
        },
      }
      this.currentParams = data
      this.getmanageCompanyindex({
        data: data,
        handle(res) {
          let list = res.message.data
          _this.list = res.message.data
          _this.pageLength = parseInt(res.message.pages)
        },
      })

    },
    //发明公开
    sortPub() {
      let _this = this
      let data = {
        params: {
          gid: 1,
          page: this.currentPageTwo,
          pageSize: this.pageSize,
          sortField: 'pa_invent_pub',
          sortDirection: 'desc',
        },
      }
      this.currentParams = data
      this.getmanageCompanyindex({
        data: data,
        handle(res) {
          let list = res.message.data
          _this.list = res.message.data
          _this.pageLength = parseInt(res.message.pages)
        },
      })

    },
    //发明总量
    sortPainvent() {
      let _this = this
      let data = {
        params: {
          gid: 1,
          page: this.currentPageThree,
          pageSize: this.pageSize,
          sortField: 'pa_invent',
          sortDirection: 'desc',
        },
      }
      this.currentParams = data
      this.getmanageCompanyindex({
        data: data,
        handle(res) {
          let list = res.message.data
          _this.list = res.message.data
          _this.pageLength = parseInt(res.message.pages)
        },
      })
    
    },
    //使用新型
    sortPautility() {
      let _this = this
      let data = {
        params: {
          gid: 1,
          page: this.currentPageFour,
          pageSize: this.pageSize,
          sortField: 'pa_utility',
          sortDirection: 'desc',
        },
      }
      this.currentParams = data
      this.getmanageCompanyindex({
        data: data,
        handle(res) {
          let list = res.message.data
          _this.list = res.message.data
          _this.pageLength = parseInt(res.message.pages)
        },
      })
    },
    //外观设计
    sortPadesign() {
      let _this = this
      let data = {
        params: {
          gid: 1,
          page: this.currentPageFive,
          pageSize: this.pageSize,
          sortField: 'pa_design',
          sortDirection: 'desc',
        },
      }
      this.currentParams = data
      this.getmanageCompanyindex({
        data: data,
        handle(res) {
          let list = res.message.data
          _this.list = res.message.data
          _this.pageLength = parseInt(res.message.pages)
        },
      })
    },
    //商标总量
    sortTm() {
      let _this = this
      let data = {
        params: {
          gid: 1,
          page: this.currentPageSix,
          pageSize: this.pageSize,
          sortField: 'tm',
          sortDirection: 'desc',
        },
      }
      this.currentParams = data
      this.getmanageCompanyindex({
        data: data,
        handle(res) {
          let list = res.message.data
          _this.list = res.message.data
          _this.pageLength = parseInt(res.message.pages)
        },
      })
    },
    //软著总量
    sortRz() {
      let _this = this
      let data = {
        params: {
          gid: 1,
          page: this.currentPageSeven,
          pageSize: this.pageSize,
          sortField: 'rz',
          sortDirection: 'desc',
        },
      }
      this.currentParams = data
      this.getmanageCompanyindex({
        data: data,
        handle(res) {
          let list = res.message.data
          _this.list = res.message.data
          _this.pageLength = parseInt(res.message.pages)
        },
      })
    },

    timeFormat(unixTime) {
      let date = new Date(unixTime)
      let Y = date.getFullYear() + '-'
      let M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      let D = date.getDate() + ' '
      let h = date.getHours() + ':'
      let m = date.getMinutes() + ':'
      let s = date.getSeconds()
      return Y + M + D + h + m + s
    },

    successMsg(msg) {
      this.$message({
        type: 'success',
        message: msg || '操作成功!',
      })
    },
    failMsg(msg) {
      this.$message({
        type: 'error',
        message: msg || '操作失败!',
      })
    },
    //
    //搜索企业的名称
    getResult() {
      let _this = this
      let data = {
        params: {
          names: this.companyName,
          page: this.currentPage,
          pageSize: this.pageSize,
        },
      }
      this.getmanageManageSearch({
        data: data,
        handle(res) {
          let list = res.message
          _this.list = res.message.data
          _this.pageLength = parseInt(res.message.pages)
        },
      })
    },
    addCompany() {
      this.form = {}
      this.addVisible = true
      this.visibleTit = '添加企业'
    },
    editCompany(value) {
      this.addVisible = true
      this.form = value
      this.visibleTit = '修改企业'
    },
    //查看详情的功能
    detailsCompany(value) {
      this.detailVisible = true
      this.form = value
      this.visibleTit = '查看企业'
    },
    //详情的关闭
    handleDetailCancel() {
      this.detailVisible = false
    },

    handleAddCancel() {
      this.addVisible = false
    },
    async onPageChange(page) {
      this.page = page
      await this.getList()
    },
    handleAddOk() {
      // this.addVisible = false
      let data = {
        params: this.form,
      }
      let _this = this
      this.getmanageManageAdd({
        data: data,
        handle(res) {
          if (res.success) {
            _this.successMsg(res.message)
            _this.addVisible = false
            _this.getList()
          } else {
            _this.failMsg(res.message)
          }
        },
      })
    },
    handleEditOk() {
      let data = {
        params: {
          id: this.form.id,
          user: this.form.user,
          name: this.form.name,
          contact: this.form.contact,
          contactPhone: this.form.contactPhone,
          description: this.form.description,
        },
      }
      let _this = this
      //编辑的接口
      this.getmanageUpdate({
        data: data,
        handle(res) {
          _this.addVisible = false
          if (res.success) {
            _this.successMsg(res.message)
            _this.getList()
          } else {
            _this.failMsg(res.message)
          }
        },
      })
    },
    //删除的table数据
    historyItemDel(id, val) {
      if (val == 'list') {
        id = id.map((item) => {
          return item.id
        })
      }
      let ids = id.join(',')
      this.$msgbox
        .confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let data = {
            params: {
              ids: ids,
            },
          }
          let _this = this
          this.getmanageManageDelete({
            data: data,
            handle(res) {
              if (res.success) {
                _this.$message({
                  type: 'success',
                  message: res.message || '操作成功',
                })
                _this.getList()
              }
            },
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
  },
}
</script>